import React, { useState } from "react";
import styled from "styled-components";
import Column from "./column";
import { useStaticQuery, graphql } from "gatsby";
import { itinerary } from "./data";
import { Pill } from "./itinerary-card";

const thumbnailsImagesQuery = graphql`
  query {
    thumbnails: allFile(
      filter: { relativePath: { regex: "/northern-territory/thumbnails/.*/" } }
    ) {
      thumbnailImages: nodes {
        sharp: childImageSharp {
          fixed(width: 210) {
            originalName
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
    details: allFile(
      filter: { relativePath: { regex: "/northern-territory/details/.*/" } }
    ) {
      detailsImages: nodes {
        sharp: childImageSharp {
          fixed(width: 450) {
            originalName
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin: 40px 30px 40px 30px;
  overflow: scroll;
  border-bottom: 4px solid #d43826;
`;

const Intro = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 50px;
  font-size: 14px;
  line-height: 19px;
  
  h3 {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 5px;
    font-family: "Libre Franklin"
  }
`;

const useImages = () => {
  const {
    thumbnails: { thumbnailImages },
    details: { detailsImages }
  } = useStaticQuery(thumbnailsImagesQuery);

  const thumbnailsObj = thumbnailImages.reduce((obj, img) => {
    const {
      sharp: { fixed }
    } = img;

    obj[fixed.originalName] = fixed;
    return obj;
  }, {});

  const detailsObj = detailsImages.reduce((obj, img) => {
    const {
      sharp: { fixed }
    } = img;

    obj[fixed.originalName] = fixed;
    return obj;
  }, {});

  return {
    thumbnails: thumbnailsObj,
    details: detailsObj
  };
};

const Itinerary = () => {
  const [expanded, setExpanded] = useState({
    day: "Day 1",
    activity: null
  });

  const images = useImages();

  return (
    <>
      <Intro>
        <h3>Itinerary</h3>
        <p>
          The following is the itinerary we followed from Dec 24 - Jan 1. This
          is actually the dry season in Uluru and the wet season in Kakadu, so
          some would say not the ideal seasons to visit. However, for us we
          kinda liked it because there were not that many people around. That
          did mean that all walks had to be done super early in the morning and
          we drove during midday when it was practically impossible to be
          outside because of the heat.
        </p>
        <p>
          <br />
          I'm using a couple of tags to identify the types of activities: <br />
          <Pill tag="highlight">highlight</Pill> is anything that in my
          opinion you definitely need to see. <br />
          Anything marked as <Pill tag="extras">extras</Pill> is if you have
          extra time you should consider. In my own case sometimes I didn't even
          get to see but still left it for reference for anyone else. <br />I
          use <Pill tag="stop">stop</Pill> for stops along the drive. Some are
          marked as highlights and are the ones we stopped on but still left
          most for you to pick.
          <br />I think <Pill tag="drive">drive</Pill>,{" "}
          <Pill tag="sleep">sleep</Pill> and the ocassional{" "}
          <Pill tag="eat">eat</Pill> are pretty self explanatory. <br /><br />
          This trip was amazing and there's a lot of stuff to see, there's stuff
          missing, specially in Kakadu, but hope you find it useful!
        </p>
        <p>
          Scroll to the right to see more of the itinerary, you can click some
          of the items for a description.
        </p>
      </Intro>
      <Container>
        {Object.keys(itinerary).map(day => {
          const column = itinerary[day];

          return (
            <Column
              key={column.columnDay}
              images={images}
              activities={column.activities}
              columnTitle={column.columnTitle}
              columnDay={column.columnDay}
              expanded={expanded}
              setExpanded={setExpanded}
            />
          );
        })}
      </Container>
    </>
  );
};

export default Itinerary;
